"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RadioText_1 = require("./RadioText");
exports.default = RadioText_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/components/RadioText/index.js
// module id = 1231
// module chunks = 8